import { InjectionToken } from '@angular/core';
import { DarkModeOptions } from '@interfaces/dark-mode-options.interface';

export const DARK_MODE_OPTIONS = new InjectionToken<Partial<DarkModeOptions>>(
  'DARK_MODE_OPTIONS'
);
